import { atom } from 'jotai';
import { atomWithRefresh } from 'jotai/utils';
import { guardedClient } from '../../../auth/api/clients';
import {
  listRecordingsResponseSchema,
  type ListRecordingsResponse,
} from '@minutes-system/backend/src/api/recordings/schema';
import fetchAndValidate from '../../../../lib/fetchAndValidate';

// APIパラメータの型
export interface RecordingsQueryParams {
  page: string;
  customerName?: string;
  customerPhone?: string;
  advisorName?: string;
  recordingStatusId?: string;
  dateFrom?: string; // ISO 8601フルフォーマット（UTC）: '2025-01-14T15:00:00.000Z'
  dateTo?: string; // ISO 8601フルフォーマット（UTC）: '2025-01-15T14:59:59.999Z'
}

// パラメータを管理するatom（内部用）
const recordingsQueryParamsBaseAtom = atom<RecordingsQueryParams>({ page: '1' });

// パラメータを管理するatom（書き込み可能、値が同じ場合は更新しない）
export const recordingsQueryParamsAtom = atom(
  get => get(recordingsQueryParamsBaseAtom),
  (get, set, newValue: RecordingsQueryParams) => {
    const currentValue = get(recordingsQueryParamsBaseAtom);
    // 値が同じ場合は更新しない（無限ループ防止）
    if (JSON.stringify(currentValue) !== JSON.stringify(newValue)) {
      set(recordingsQueryParamsBaseAtom, newValue);
    }
  }
);

// パラメータに依存する非同期atom（インスタンスは1つ、パラメータ変更で自動再取得）
export const recordingsAtom = atomWithRefresh<Promise<ListRecordingsResponse>>(get => {
  const params = get(recordingsQueryParamsAtom);
  return fetchAndValidate(
    guardedClient.recordings.$get({ query: params }) as Promise<Response>,
    listRecordingsResponseSchema
  );
});
